import { Injectable, EventEmitter } from '@angular/core';

import { HubConnection, HubConnectionBuilder } from "@aspnet/signalr";

import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

import { IOfficeTicker } from '../interfaces/offices/office-ticker';
import { IIdResult } from '../interfaces/id-result';

@Injectable({
  providedIn: 'root'
})
export class TickerMonthService {

  private tickerPath = environment.hubUrl + 'ticker_month';
  

  private hubConnection: HubConnection;
  intervalId: any;

  public data: IOfficeTicker[];
  public dataRecievedEvent: EventEmitter<any> = new EventEmitter();
  public updateRecievedEvent: EventEmitter<string> = new EventEmitter();
  private TIME_INTERVAL: number = 60;

  constructor(
    private authService: AuthService
  ) { }

  public get total(): number {
    if (this.data) {
      return this.data.reduce((sum, current) => sum + current.monthlySalesCount, 0);
    }
    return 0;
  }

  public startConnection(): void {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(this.tickerPath, { accessTokenFactory: () => this.authService.getToken() })
      .build();

    this.start();

    this.hubConnection.onclose(() => {

      this.intervalId = setInterval(() => {

        if (this.hubConnection.state == 0) {
          this.start();
        } else {
          clearInterval(this.intervalId);
        }
      }, 1 * this.TIME_INTERVAL * 1000)
    });
  }

  private start() {
    try {
      this.hubConnection.start();
    } catch (error) {
      console.log('Failure to connect to Hub');
    }
  }

  public stopConnection(): void {
    this.hubConnection.stop();
  }

  public addTickerListener(): void {
    this.hubConnection.on('data', (data: IOfficeTicker[]) => {
      this.data = data;
      this.dataRecievedEvent.emit();
      
    });
    this.hubConnection.on('update', (update: IIdResult) => {
      this.data.find(x => x.id == update.id).monthlySalesCount++;
      this.updateRecievedEvent.emit(update.id);
    });
  }
}
